import dayjs from 'dayjs';

import { CONSUMPTION_LIMIT } from '@/utils/constants';

export default () => ({
  creatingOrder: false,
  creatingSchedule: false,
  departments: [],
  draftOrder: {
    enableSendLineNotifyInReceiveTime: false,
    endTime: dayjs().add(2, 'hour').format(),
    limit: CONSUMPTION_LIMIT.NO_LIMIT,
    limitAmount: 0,
    menuId: null,
    name: '',
    note: '',
    notifyDeadline: false,
    notifyReserve: false,
    notifyStart: false,
    shiftMin: 30,
    startTime: dayjs().format(),
    storeId: null,
    subsidy: 0,
    tags: [],
    teamGroupBuyingReceiveTimes: [
      {
        startTime: dayjs().add(2, 'hour').format(),
        endTime: dayjs().add(3, 'hour').format(),
      },
    ],
  },
  gettingOrders: false,
  gettingSchedules: false,
  isGettingDraft: false,
  orders: {},
  schedule: {},
  schedules: {},
  updateOrderFail: false,
});
